import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { Collapse } from "../utils/local-antd";
import type { CollapseProps } from "../utils/local-antd";
import React from "react";
import styled from "styled-components";

import { AtiraIcon } from "./AtiraIcon";
import { Flex } from "./Flex";
import { Spacing } from "../theme/Spacing";
import { Rounded } from "../theme/Rounded";

const StyledCollapse = styled(Collapse)`
  overflow: hidden;

  .ant-collapse-title {
    flex-grow: 1 !important;
  }

  .ant-collapse-header {
    align-items: center !important;
  }

  .ant-collapse-header-text {
    margin-inline-end: 0 !important;
    flex-grow: 1 !important;
  }

  .ant-collapse-expand-icon {
    margin-inline-start: ${Spacing.m} !important;
  }

  /* In right-to-left antd turns its own arrow around, on top of the turn the
     icon below already makes between closed and open */
  .ant-collapse-arrow {
    transform: none !important;
  }
`;

// The rotation is an inline style on the icon itself, not a dynamic prop on
// this wrapper: `Flex` funnels its own recognized style props through an
// `.attrs()` block, which a same-named prop on a `styled(Flex)` wrapper isn't
// guaranteed to win against.
const ExpandIconButton = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  min-width: 1.75rem;
  border-radius: ${Rounded.circle};
  background: ${({ theme }) => theme.sub};
  cursor: pointer;
`;

export const AtiraCollapse: React.FC<CollapseProps> = ({
  items = [],
  defaultActiveKey = ["1"],
  bordered,
  accordion,
  expandIconPlacement = "start",
  collapsible = "header",
  ...props
}) => {
  return (
    <StyledCollapse
      items={items}
      defaultActiveKey={defaultActiveKey}
      bordered={bordered}
      accordion={accordion}
      expandIconPlacement={expandIconPlacement}
      collapsible={collapsible}
      expandIcon={({ isActive }) => (
        <ExpandIconButton>
          <AtiraIcon
            icon={faChevronDown}
            color="main"
            size="sm"
            style={{
              transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.15s ease",
            }}
          />
        </ExpandIconButton>
      )}
      {...props}
    />
  );
};
